import { trpc } from "@api/client";

export const useUpdateStepStatus = (
  companyId: string,
  options?: {
    forceUpdateSetup?: boolean;
  }
) => {
  const utils = trpc.useUtils();

  const { mutateAsync, error } = trpc.updateStepStatus.useMutation({
    onSuccess: (updatedSetup) => {
      if (options?.forceUpdateSetup) {
        utils.getSetup.setData({ companyId }, (oldSetup) => {
          return { ...oldSetup, ...updatedSetup };
        });
      }
    },
  });

  return { updateStepStatus: mutateAsync, error };
};
